"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var SettingsChildrenStats_1 = require("./SettingsChildrenStats");
/**
 * DTO object for page that displays overview of all general settings.
 * This object represents single line.
 *
 * @author RV
 * @author Radek Beran (release-specific data)
 */


var SettingsOverviewDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SettingsOverviewDTO, _DomainObject_1$Domai);

  /**
   *
   * @param productCategoryId
   * @param settingsZonesOverviewDTO
   * @param includedInRelease flag denoting product category is included in release; null if this is not release-scoped settings
   */
  function SettingsOverviewDTO(productCategoryId, settingsZonesOverviewDTO, includedInRelease, inPathToIncluded, childrenStats) {
    var _this;

    _classCallCheck(this, SettingsOverviewDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SettingsOverviewDTO).call(this));
    _this.productCategoryId = productCategoryId;
    _this.settingsZonesOverviewDTO = settingsZonesOverviewDTO;
    _this.includedInRelease = includedInRelease;
    _this.inPathToIncluded = inPathToIncluded;
    _this.childrenStats = childrenStats;
    return _this;
  }

  return SettingsOverviewDTO;
}(DomainObject_1.DomainObject);

exports.SettingsOverviewDTO = SettingsOverviewDTO; // tslint:disable-next-line:member-ordering

SettingsOverviewDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SettingsOverviewDTO.name);
  return {
    productCategoryId: builder.id('productCategoryId'),
    settingsZonesOverviewDTO: builder.listOf(builder.data('settingsZonesOverviewDTO', {
      zoneId: builder.str('zoneId'),
      isInherited: builder.opt(builder.bool('isInherited'))
    })),
    includedInRelease: builder.opt(builder.bool('includedInRelease')),
    inPathToIncluded: builder.opt(builder.bool('inPathToIncluded')),
    childrenStats: builder.opt(builder.obj('childrenStats', SettingsChildrenStats_1.SettingsChildrenStats.schema, function (mat) {
      return SettingsChildrenStats_1.SettingsChildrenStats.fromDataDict(mat);
    }))
  };
}();